import type { SVGProps } from 'react';
const SvgPagLeftArrowOne = (props: SVGProps<SVGSVGElement>) => (
  
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2265 12L13.1665 11.06L10.1132 8L13.1665 4.94L12.2265 4L8.2265 8L12.2265 12Z"
      fill={props.fill}
    />
    <path
      d="M7.83344 12L8.77344 11.06L5.7201 8L8.77344 4.94L7.83344 4L3.83344 8L7.83344 12Z"
      fill={props.fill}
    />
  </svg>
);
export default SvgPagLeftArrowOne;
